import { EXAMPLE_QUESTIONS } from './constants'

interface EmptyStateProps {
  onSelectExample?: (question: string) => void
}

export function EmptyState({ onSelectExample }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center">
      <span className="text-6xl mb-4 opacity-30">🔮</span>
      <h3 className="text-lg text-star-muted mb-2">Ready to Predict</h3>
      <p className="text-star-dim text-sm max-w-md">
        Enter a question above to get an AI-powered probability forecast. Our system analyzes
        your question, gathers evidence, and synthesizes multiple expert perspectives.
      </p>
      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3 text-left text-xs text-star-dim max-w-lg">
        {EXAMPLE_QUESTIONS.map((example, i) => (
          <button
            key={i}
            onClick={() => onSelectExample?.(example.text)}
            className="p-3 bg-void-50 rounded-lg hover:bg-void-100 transition-colors text-left group"
          >
            <span className={`mr-1 ${
              example.category === 'Crypto' ? 'text-signal-amber' :
              example.category === 'Sports' ? 'text-signal-green' :
              example.category === 'Politics' ? 'text-signal-red' :
              'text-signal-blue'
            }`}>
              {example.icon}
            </span>
            <span className="group-hover:text-star transition-colors">"{example.text}"</span>
          </button>
        ))}
      </div>
    </div>
  )
}
